import React from "react";
import { MapPin, ExternalLink } from "lucide-react";
import { IndexNo } from "./SectionHead";
import { OFFICE, OFFICE_MAPS_URL, OFFICE_EMBED_URL } from "@/data/office";

const INFO = [
  { k: "RESPONSE", v: "By email, within one business day", id: "email" },
  { k: "SERVING", v: "Industrial & petrochemical facilities across Saudi Arabia and the Gulf region", id: "location" },
  { k: "AVAILABILITY", v: "Sun–Thu · Technical support available", id: "hours" },
];

export const ContactInfo = () => (
  <div>
    <IndexNo no="04" label="Get in touch" />
    <h2 className="font-display font-bold text-[24px] sm:text-[28px] lg:text-[32px] leading-[1.15] text-[#04162E]">
      Initiate a technical inquiry
    </h2>
    <p className="mt-3.5 font-body text-[15px] leading-[1.65] text-[#5C6C80]">
      Tell us about your facility and the process safety challenge you're facing. An engineer will
      reply by email with a scoped path forward.
    </p>

    <div className="mt-7">
      <div data-testid="contact-info-office" className="py-[18px] border-t border-[rgba(4,22,46,0.14)]">
        <div className="font-body text-xs text-[#8FA0B3] mb-1.5">OFFICE</div>
        <a
          href={OFFICE_MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-office-link"
          className="group inline-flex items-start gap-2 text-[15.5px] font-semibold text-[#04162E] hover:text-[#0B6B44] transition-colors"
        >
          <MapPin className="h-4 w-4 mt-1 shrink-0 text-[#0E8A57]" />
          <span>
            {OFFICE.line1}
            <br />
            {OFFICE.line2}
            <ExternalLink className="inline-block h-3 w-3 ml-1.5 -mt-0.5 opacity-0 group-hover:opacity-100 transition-opacity" />
          </span>
        </a>
      </div>
      {INFO.map((it) => (
        <div
          key={it.k}
          data-testid={`contact-info-${it.id}`}
          className="py-[18px] border-t border-[rgba(4,22,46,0.14)] last:border-b"
        >
          <div className="font-body text-xs text-[#8FA0B3] mb-1.5">{it.k}</div>
          <div className="text-[15.5px] font-semibold text-[#04162E]">{it.v}</div>
        </div>
      ))}
    </div>

    <div className="mt-7 border border-[rgba(4,22,46,0.14)] bg-[#EAEDE7]" data-testid="contact-map">
      <iframe
        title="PSIEC office location — Al Jubail, Saudi Arabia"
        src={OFFICE_EMBED_URL}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="block w-full h-[240px] [filter:saturate(0.8)_contrast(1.02)]"
      />
    </div>
  </div>
);
